import React from "react";
import { cn } from "src/utils/cn";
import { BRAND } from "src/config/brand";
import { PropertyMakersMark } from "src/components/PropertyMakersMark";
import logoUrl from "src/assets/property-makers-logo.png";

const SIZES = {
    default: { mark: 34, text: "text-xl", tile: "h-9 w-9 rounded-[10px]", imgH: 52 },
    lg: { mark: 52, text: "text-3xl", tile: "h-14 w-14 rounded-2xl", imgH: 72 },
};

// PropertyMakers logo.
//
// variant "default" -> light surfaces (sidebar, invitations): the real
//                      two-row Property Makers image logo (white background reads
//                      cleanly on light grounds).
// variant "white"   -> dark surfaces (auth brand panel): the SVG rooftops mark +
//                      wordmark, since a white-background image wouldn't sit well
//                      on the dark panel.
export function Logo({ className = "", variant = "default", size = "default" }) {
    const isWhite = variant === "white";
    const { mark: markSize, text: textClass, imgH } = SIZES[size] || SIZES.default;
    const { gold } = BRAND.colors;

    if (!isWhite) {
        return (
            <div className={cn("flex items-center", className)}>
                <img src={logoUrl} alt="Property Makers" className="w-auto rounded-md" style={{ height: imgH }} />
            </div>
        );
    }

    return (
        <div className={cn("flex items-center gap-2.5", className)}>
            <PropertyMakersMark size={markSize} navy="#FFFFFF" gold={gold} />
            <span className={cn("font-bold tracking-tight", textClass)}>
                <span className="text-white">Property</span>
                <span style={{ color: gold }}>Makers</span>
            </span>
        </div>
    );
}
